import { useTranslation } from 'react-i18next';

const WhyChooseUs = () => {
  const { t } = useTranslation();

  const reasons = [
    {
      titleKey: 'whyUs.item1Title', descKey: 'whyUs.item1Desc',
      icon: 'ri-lightbulb-flash-line',
      color: 'bg-amber-50 border-amber-100', iconBg: 'bg-amber-100', iconColor: 'text-amber-600', accent: 'bg-amber-500',
    },
    {
      titleKey: 'whyUs.item2Title', descKey: 'whyUs.item2Desc',
      icon: 'ri-speed-up-line',
      color: 'bg-rose-50 border-rose-100', iconBg: 'bg-rose-100', iconColor: 'text-rose-600', accent: 'bg-rose-500',
    },
    {
      titleKey: 'whyUs.item3Title', descKey: 'whyUs.item3Desc',
      icon: 'ri-customer-service-2-line',
      color: 'bg-emerald-50 border-emerald-100', iconBg: 'bg-emerald-100', iconColor: 'text-emerald-600', accent: 'bg-emerald-500',
    },
    {
      titleKey: 'whyUs.item4Title', descKey: 'whyUs.item4Desc',
      icon: 'ri-earth-line',
      color: 'bg-sky-50 border-sky-100', iconBg: 'bg-sky-100', iconColor: 'text-sky-600', accent: 'bg-sky-500',
    },
    {
      titleKey: 'whyUs.item5Title', descKey: 'whyUs.item5Desc',
      icon: 'ri-shield-check-line',
      color: 'bg-violet-50 border-violet-100', iconBg: 'bg-violet-100', iconColor: 'text-violet-600', accent: 'bg-violet-500',
    },
    {
      titleKey: 'whyUs.item6Title', descKey: 'whyUs.item6Desc',
      icon: 'ri-refresh-line',
      color: 'bg-orange-50 border-orange-100', iconBg: 'bg-orange-100', iconColor: 'text-orange-600', accent: 'bg-orange-500',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <p className="text-brand-red font-semibold text-sm uppercase tracking-widest mb-3">{t('whyUs.label')}</p>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight max-w-md">
              {t('whyUs.title')}
            </h2>
          </div>
          <p className="text-gray-500 text-base max-w-sm leading-relaxed">
            {t('whyUs.desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((item, i) => (
            <div
              key={item.titleKey}
              className={`group relative p-7 rounded-2xl border ${item.color} hover:-translate-y-1.5 hover:shadow-lg transition-all duration-400 cursor-default overflow-hidden`}
            >
              <div className={`absolute top-0 left-0 h-1 w-0 group-hover:w-full ${item.accent} transition-all duration-500 rounded-t-2xl rtl:left-auto rtl:right-0`}></div>
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.iconBg} mb-5`}>
                <i className={`${item.icon} ${item.iconColor} text-xl`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-lg mb-3">{t(item.titleKey)}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{t(item.descKey)}</p>
              <div className="mt-5 flex items-center gap-1.5 text-xs font-semibold text-gray-400 group-hover:text-gray-600 transition-colors">
                <span>0{i + 1}</span>
                <span className="flex-1 h-px bg-gray-200"></span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
